export default class SimpleFormatter {
  format(filterValue) {
    if (filterValue == null) {
      return '';
    } else {
      return filterValue.toString();
    }
  }

  formatRange(filterMinValue, filterMaxValue) {
    if (filterMinValue && filterMaxValue) {
      return `${filterMinValue} - ${filterMaxValue}`;
    } else {
      return this.format(filterMinValue || filterMaxValue);
    }
  }
}
